import { computed, unref, reactive } from '@vue/composition-api';
import { createContext, useContext } from '@berlin-front/common/composables/context';
import { broadcast } from '@/broadcast';
import { GlobalApiErrorContext } from '@/services/GlobalApiErrorContext';
import { getUniqueArray } from '@berlin-front/common/utils';

export const useSystemErrorFactory = () => ({
  useSystemError: () => {
    const globalApiErrorContext = useContext(GlobalApiErrorContext);
    const errors = computed(() => getUniqueArray(Object.values(unref(globalApiErrorContext.errors)).flat()).join(`\n`));
    const selectAnotherPayment = () => {
      broadcast.send({
        type: 'MODAL_CONTROL_FAILED',
        payload: {
          noResult: true,
        },
      });
    };

    return reactive({
      selectAnotherPayment,
      errors,
    });
  },
});

export type SystemErrorViewContextType = ReturnType<typeof useSystemErrorFactory>;
export const SystemErrorViewContext = createContext<SystemErrorViewContextType>(() => useSystemErrorFactory());
